<div class="credit-card-item">
    <div class="card-content">
        <div 
          class="card-icon" 
          [class]="cardFlag.toLowerCase()"
          role="img"
          [attr.aria-label]="cardFlag + ' logo'">
        </div>
        <span class="card-label">{{ cardFlag === 'UNKNOWN' ? 'Cartão' : ( cardFlag | titlecase) }} **** {{ lastFourDigits }}</span>
    </div>
</div>